import getWishlists from './getCacheableWishlists.js';
import findWishlistFromList from './findWishlistFromList.js';

export default (prid, catalog, force = false) =>
  getWishlists(force).then((wishlists) => findWishlistFromList(wishlists, prid, catalog));
